import { useQuery } from '@tanstack/react-query';
import useBusiness from '../businesses/useBusiness';
import { getBusinessFlashDays } from '../../services/flashbooks';

function useGetBusinessFlashDays({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const { business } = useBusiness();
  const businessId = business?.id;

  return useQuery({
    queryKey: ['flashbook', 'business', businessId, 'flash-days'],
    enabled: !!businessId && enabled,
    queryFn: () => getBusinessFlashDays(businessId!),
  });
}

export default useGetBusinessFlashDays;
